import { TeamScore } from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'

export const PRESENTER_TEAM_SCORING_TEST_SCORES: TeamScore[] = [
  {
    uuid: '001',
    name: 'Corporate Changers',
    order: 1,
    score: '12450.00',
  },
  {
    uuid: '002',
    name: 'The Hope Horizon Trust',
    order: 2,
    score: '10200',
  },
  {
    uuid: '003',
    name: 'Global Impact Pioneers',
    order: 3,
    score: '9850',
  },
  {
    uuid: '004',
    name: 'Beacon of Light Foundation',
    order: 4,
    score: '8100',
  },
  {
    uuid: '005',
    name: 'Legacy Builders Initiative',
    order: 5,
    score: '7600',
  },
  {
    uuid: '006',
    name: 'Nexus Network Alliance',
    order: 6,
    score: '6250',
  },
  {
    uuid: '007',
    name: 'Synergy for Change',
    order: 7,
    score: '5900',
  },
  {
    uuid: '008',
    name: 'The Catalyst Collective',
    order: 8,
    score: '4150',
  },
  {
    uuid: '009',
    name: 'Vanguard Visionaries',
    order: 9,
    score: '3800',
  },
  {
    uuid: '010',
    name: 'Summit Philanthropy Group',
    order: 10,
    score: '2500',
  },
]
